import { TemperatureApiModel } from '@era/inroom-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { TemperatureActionsUnion, TemperatureActionTypes, TemperatureLocationModel } from './temperature.actions';

export const inRoomTemperatureFeatureKey = 'inroom-temperature';

export type TemperatureState = EntityState<TemperatureApiModel>;

export function selectTemperatureidFromTemperature(temperature: TemperatureLocationModel) {
  return selectTemperatureId(temperature.HotelCode ?? '', temperature.Room ?? '');
}

export function selectTemperatureId(location: string, room: string) {
  return location + '-' + room;
}

export const adapter: EntityAdapter<TemperatureLocationModel> = createEntityAdapter<TemperatureLocationModel>({
  selectId: selectTemperatureidFromTemperature,
});

export const initialState: TemperatureState = adapter.getInitialState();

export function temperatureReducer(state: TemperatureState = initialState, action: TemperatureActionsUnion) {
  switch (action.type) {
    case TemperatureActionTypes.LOAD_TEMPERATURE:
      return adapter.addOne(action.payload, state);
    case TemperatureActionTypes.UPDATE_TEMPERATURE:
      return adapter.updateOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectTemperatureIds = selectIds;

export const selectTemperatureEntities = selectEntities;

export const selectAllTemperatures = selectAll;

export const selectTemperatureTotal = selectTotal;
